export default __webpack_public_path__ + "static/media/Webinar_Autobuses_de_personal_final.0a3f55de.pdf";